import TuneIcon from '@mui/icons-material/Tune';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Typography, Stack, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
const TopBar = ({sideBarOpen, setSideBarOpen}) => {
    return (
        <Stack sx={{ padding: '10px'}} direction="row" alignItems="center" justifyContent="space-between">
            <IconButton onClick={()=>{setSideBarOpen(!sideBarOpen)}}><MenuIcon/></IconButton>
            <Typography sx={{fontWeight: 'bold', fontSize: '1.5rem'}} >Turf</Typography>
            <Stack direction="row">
                <Stack alignItems="center">
                    <IconButton><TuneIcon/></IconButton>
                    <Typography sx={{fontSize: '0.6rem'}}>Filter</Typography>
                </Stack>
                <Stack alignItems="center">
                    <IconButton><LocationOnIcon/></IconButton>
                    <Typography sx={{fontSize: '0.6rem'}}>Perinthalmanna</Typography>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default TopBar